import { useSetRecoilState } from "recoil";
import { get, post } from "..";
import { authState } from "recoil/auth";

const useReceiptActions = () => {
  const setAuth = useSetRecoilState(authState);
  async function login(params) {
    const res = await post("login/tester", params);
    localStorage.setItem("authInfo", JSON.stringify(res));
    setAuth(res);
    return res;
  }

  async function apply(params) {
    params.uuid = "c9171b02-ff10-49c2-8112-82c14c911f8c"
    const res = await post("application/applicationform", params);

    if (res?.status === 200) return res;
    else throw Error(res?.status);
  }

  async function uploadFile(params) {
    const res = await post("index/uploadFile", params);
    return res;
  }

  async function fetchApplicationForm(params) {
    const res = await get("application/applicationform", params);
    return res;
  }

  async function receiptlink(params) {
    const res = await get("index/receiptlink", params);
    return res;
  }

  return { login, apply, uploadFile, fetchApplicationForm, receiptlink };

  /**
   *
   * @param {Number} type
   * @param {String} id
   * @param {String} password
   * @param {String} name
   * @returns {Promise<Object>}
   */
};

export default useReceiptActions;
